import { Controller } from "@hotwired/stimulus"
import { currentOfferState, formatRemaining } from "../lib/offer_countdown"

// Connects to data-controller="credit-package"
export default class extends Controller {
  static targets = ["button", "creditAmount", "price", "hiddenAmount", "hiddenPackageId", "timer", "offer"]

  connect() {
    const defaultButton = this.buttonTargets.find(button => button.dataset.default === "true") ||
      this.buttonTargets.find(button => parseInt(button.dataset.amount, 10) === 25) ||
      this.buttonTargets[0]

    if (defaultButton) {
      this.selectPackage({ target: defaultButton })
    }

    this.startCountdown()
  }

  disconnect() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
      this.countdownInterval = null
    }
  }

  selectPackage(event) {
    const button = event.target.closest("[data-credit-package-target='button']")
    if (!button) return

    const amount = parseInt(button.dataset.amount, 10)
    const credits = parseInt(button.dataset.credits, 10)

    this.buttonTargets.forEach(btn => {
      btn.classList.remove("bg-[#6C2BD9]", "scale-105", "ring-2", "selected")
      btn.classList.add("bg-gray-800/50")
    })

    button.classList.remove("bg-gray-800/50")
    button.classList.add("bg-[#6C2BD9]", "scale-105", "ring-2", "selected")

    this.creditAmountTarget.textContent = credits
    this.priceTarget.textContent = amount
    
    // Only update hidden field if it exists (user is signed in)
    if (this.hasHiddenAmountTarget) {
      this.hiddenAmountTarget.value = amount
    }

    if (this.hasHiddenPackageIdTarget) {
      this.hiddenPackageIdTarget.value = button.dataset.packageId
    }
  }

  startCountdown() {
    if (!this.hasTimerTarget) return

    this.updateOffer()
    this.countdownInterval = setInterval(() => this.updateOffer(), 1000)
  }

  updateOffer() {
    const state = currentOfferState()

    if (state.active) {
      this.timerTarget.textContent = formatRemaining(state.deadline)
    }

    if (this.hasOfferTarget) {
      this.offerTarget.classList.toggle("hidden", !state.active)
    }
  }
}
